export enum ProsecutionViolationResult {
	SufficientForProsecution = 1,
	Insufficient = 2,
	NeedsCompletion = 3,
}
